import { render, staticRenderFns } from "./NewTrainedPersonnel.vue?vue&type=template&id=4ddda240&scoped=true"
import script from "./NewTrainedPersonnel.vue?vue&type=script&lang=js"
export * from "./NewTrainedPersonnel.vue?vue&type=script&lang=js"
import style0 from "./NewTrainedPersonnel.vue?vue&type=style&index=0&id=4ddda240&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddda240",
  null
  
)

export default component.exports